/**
 * sound_preview_controller.js — audition a notification sound in Settings.
 *
 * Scopes a sound <select> plus its play button (data-controller="sound-preview").
 * Clicking the button plays the URL carried on the currently-selected option
 * (data-sound-url, set by the template from the sound catalog); the Silent
 * option carries an empty URL and is a no-op. One Audio per URL is cached and
 * reused so re-auditioning the same sound never re-fetches. play() is wrapped
 * because browsers reject autoplay until a gesture — the click here IS the
 * gesture, so it normally resolves, but a rejection is swallowed regardless.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
        static targets = ['select'];

        play() {
            const select = this.hasSelectTarget ? this.selectTarget
                                                 : this.element.querySelector('select');
            if (!select) return;
            const option = select.options[select.selectedIndex];
            const url = option && option.dataset.soundUrl;
            if (!url) return;  // Silent

            if (!this._cache) this._cache = {};
            let audio = this._cache[url];
            if (!audio) {
                audio = new Audio(url);
                audio.preload = 'auto';
                this._cache[url] = audio;
            }
            try {
                audio.currentTime = 0;
                const p = audio.play();
                if (p && typeof p.catch === 'function') p.catch(() => {});
            } catch (_err) { /* unsupported — ignore */ }
        }
}
